var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.106 39H134.876C137.836 39 140.036 41.73 139.416 44.62L131.686 80.6799H73.416L81.556 42.6699C82.016 40.5299 83.906 39 86.096 39H86.106Z",
    fill: "#7A5FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4859 43.38H123.436C124.826 43.38 125.866 44.6699 125.576 46.0299L120.396 70.23C120.176 71.24 119.286 71.96 118.256 71.96H82.306C80.916 71.96 79.876 70.6699 80.166 69.3099L85.346 45.11C85.566 44.1 86.4559 43.38 87.4859 43.38Z",
    fill: "#80D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.185 43.38L127.285 80.5H52.1152",
    stroke: "#5E4BE2",
    strokeWidth: 8.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardComputer);
export default __webpack_public_path__ + "static/media/card_computer.cd1897533252f395ecdbf677e5c4244b.svg";
export { ForwardRef as ReactComponent };